module.exports = __webpack_public_path__ + "static/img/act0417.5a095ef5.png";